import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../App";
import { Badge } from "../ui/badge";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const AdminAllDeals = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const response = await axios.get(`${API}/crm/deals`, { withCredentials: true });
      setDeals(response.data);
    } catch (error) {
      toast.error("Failed to fetch deals");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-8"><Loader2 className="w-8 h-8 animate-spin" /></div>;
  }

  const deleteDeal = async (dealId) => {
    if (!window.confirm("Are you sure you want to delete this deal?")) return;
    setDeletingId(dealId);
    try {
      await axios.delete(`${API}/crm/deals/${dealId}`, { withCredentials: true });
      toast.success("Deal deleted");
      fetchDeals();
    } catch (error) {
      toast.error("Failed to delete deal");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-serif">All Deals</h2>
        <p className="text-muted-foreground text-sm">View all deals from all agents. Total: {deals.length}</p>
      </div>

      <div className="bg-card border border-border rounded-sm overflow-hidden">
        <div className="grid grid-cols-12 gap-4 p-4 bg-muted text-sm font-medium">
          <div className="col-span-3">Client</div>
          <div className="col-span-2">Value</div>
          <div className="col-span-2">Stage</div>
          <div className="col-span-2">Agent</div>
          <div className="col-span-2">Date</div>
          <div className="col-span-1"></div>
        </div>
        <div className="divide-y divide-border max-h-[500px] overflow-y-auto">
          {deals.map((deal) => (
            <div key={deal.deal_id} className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-muted/50">
              <div className="col-span-3 font-medium">{deal.title || deal.client_name}</div>
              <div className="col-span-2 text-sm font-medium text-primary">K {deal.value?.toLocaleString()}</div>
              <div className="col-span-2">
                <Badge variant={deal.status === "closed_won" ? "default" : deal.status === "closed_lost" ? "destructive" : "secondary"}>
                  {deal.status?.replace("_", " ")}
                </Badge>
              </div>
              <div className="col-span-2 text-sm">{deal.agent_name || deal.agent?.name || "Unassigned"}</div>
              <div className="col-span-2 text-sm text-muted-foreground">
                {deal.created_at ? new Date(deal.created_at).toLocaleDateString() : "-"}
              </div>
              <div className="col-span-1 text-right">
                <button
                  onClick={() => deleteDeal(deal.deal_id)}
                  disabled={deletingId === deal.deal_id}
                  className="p-1.5 text-muted-foreground hover:text-destructive transition-colors rounded hover:bg-destructive/10 disabled:opacity-50"
                  data-testid={`admin-delete-deal-${deal.deal_id}`}
                  title="Delete deal"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminAllDeals;
